import * as _ from 'lodash';
import { API, Auth } from 'aws-amplify';

import {
    CLEAR_STORE,
    TEMP_SAVE_COGNITO_USER,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    CLEAR_USER_LOGIN_ERROR,
    SET_USER_LOGIN_ERROR,
    USER_LOGIN,
    USER_LOGIN_FAIL,
    FETCH_MY_PROFILE_SUCCESS,

    CREATE_USER,
    CREATE_USER_SUCCESS,
    CREATE_USER_ERROR,

    FETCH_COMPANY_USERS,
    FETCH_COMPANY_USERS_SUCCESS,
    FETCH_COMPANY_USERS_ERROR,

    COMPANY_NOTICE_SEEN_SUCCESS,

    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_ERROR,
    CLEAR_CHANGE_PW_ERROR,

    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_REQUEST_SUCCESS,
    FORGOT_PASSWORD_REQUEST_ERROR,

    FORGOT_PASSWORD_CONFIRM,
    FORGOT_PASSWORD_CONFIRM_SUCCESS,
    FORGOT_PASSWORD_CONFIRM_ERROR,

    UPDATE_USER_PROFILE,
    UPDATE_USER_PROFILE_SUCCESS,
    UPDATE_USER_PROFILE_FAIL,

    USER_REGISTER,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL
} from './types';
import { signInWithUsername, completeNewPassword, logout } from '../utils/auth';
import { uploadImgToS3 } from '../utils/S3Utils'
import { showModal } from './'

export const signIn = (username, password, history) => {
    return async (dispatch) => {
        if (_.isEmpty(username)) {
            dispatch({ type: USER_LOGIN_FAIL, payload: { errorMessage: "Email cannot be empty" } })
            return
        }
        if (_.isEmpty(password)) {
            dispatch({ type: USER_LOGIN_FAIL, payload: { errorMessage: "Password cannot be empty" } })
            return
        }
        dispatch({ type: USER_LOGIN })
        try {
            const user = await signInWithUsername(username, password)
            console.log('signin successfull: ', user)

            if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                console.log("NEW_PASSWORD_REQUIRED")
                console.log(history)
                dispatch({ type: TEMP_SAVE_COGNITO_USER, payload: { user } })
                history.push({ pathname: '/changePassword', state: { showTooltip: true, toolTipMessage: "Please setup a new password for your account to continue" } })
            } else {
                let cs = await Auth.currentSession()
                console.log('currentSession: ', cs)
                let isAdmin = _.includes(_.get(cs, 'accessToken.payload.cognito:groups', []), 'Admin')
                console.log('isAdmin', isAdmin)
                dispatch({ type: LOGIN_SUCCESS, payload: { isAdmin } })
                dispatch(fetchMyProfile())
                history.push('/dashboard')
            }
        } catch (err) {
            console.log(err)
            if (err.code === "UserNotFoundException") {
                dispatch({ type: USER_LOGIN_FAIL, payload: { errorMessage: 'User does not exist' } })
            } else if (err.code === "NotAuthorizedException") {
                if (err.message === "Password attempts exceeded") {
                    dispatch({ type: USER_LOGIN_FAIL, payload: { errorMessage: "Password attempts exceeded, please try again later" } })
                } else {
                    dispatch({ type: USER_LOGIN_FAIL, payload: { errorMessage: 'Incorrect email or password' } })
                }
            } else {
                dispatch({ type: USER_LOGIN_FAIL, payload: { errorMessage: "Error in login, please check your credentials and try again" } })
            }
        }
    }
}

export const changePasswordAtFirstLogin = (user, newPassword, history) => {
    return async (dispatch) => {
        dispatch({ type: CHANGE_PASSWORD })
        try {
            const cognitoUser = await completeNewPassword(user, newPassword)
            console.log('complete password successfull: ', cognitoUser)
            history.push({ pathname: '/login', state: { showTooltip: true, toolTipMessage: "Please login with new credentials to continue" } })
            dispatch({ type: CHANGE_PASSWORD_SUCCESS })
            dispatch(fetchMyProfile())
        } catch (err) {
            console.log(err)
            dispatch({ type: CHANGE_PASSWORD_ERROR, payload: { error: "Error in password change" } })
        }
    }
}

export const changePassword = (oldPassword, newPassword, callback) => {
    return async (dispatch) => {
        dispatch({ type: CHANGE_PASSWORD })
        try {
            let user = await Auth.currentAuthenticatedUser()
            await Auth.changePassword(user, oldPassword, newPassword);
            console.log('change password successfull')
            callback()
            dispatch({ type: CHANGE_PASSWORD_SUCCESS })
        } catch (err) {
            console.log(err)
            let errorMessage = 'Error in password change'
            if (err.code === 'NotAuthorizedException') {
                errorMessage = "The old password you entered was incorrect"
            } else if (err.code === 'InvalidParameterException') {
                errorMessage = "The new password must have at least 6 characters"
            } else if (err.code === 'LimitExceededException') {
                errorMessage = "Attempt limit exceeded, please try after some time"
            }
            dispatch({ type: CHANGE_PASSWORD_ERROR, payload: { error: errorMessage } })
        }
    }
}

export const clearChangePWError = () => {
    return { type: CLEAR_CHANGE_PW_ERROR }
}

export const setConfirmPWError = (errorMessage) => {
    return { type: FORGOT_PASSWORD_CONFIRM_ERROR, payload: { errorMessage } }
}

export const clearLoginPWError = () => {
    return { type: CLEAR_USER_LOGIN_ERROR }
}

export const setLoginPWError = (errorMessage) => {
    return { type: SET_USER_LOGIN_ERROR, payload: { errorMessage } }
}

export const forgotPasswordRequest = (username, history) => {
    return async (dispatch) => {
        dispatch({ type: FORGOT_PASSWORD_REQUEST })
        try {
            await Auth.forgotPassword(username)
            console.log("Forgot password request is sent successfully")
            dispatch({ type: FORGOT_PASSWORD_REQUEST_SUCCESS })
            // go to confirmation view
            history.push({ pathname: '/changePassword/', state: { showCode: true, username, showTooltip: true, toolTipMessage: `Please enter the verification code sent to ${username}` } })
        } catch (err) {
            console.log(err)
            if (err.code === "UserNotFoundException") {
                dispatch({ type: FORGOT_PASSWORD_REQUEST_ERROR, payload: { errorMessage: "Email not found" } })
            } else {
                dispatch({ type: FORGOT_PASSWORD_REQUEST_ERROR, payload: { errorMessage: "Something went wrong, please try again later" } })
            }
        }
    }
}

export const forgotPasswordConfirmCode = (username, code, newPassword, history) => {
    return async (dispatch) => {
        dispatch({ type: FORGOT_PASSWORD_CONFIRM })
        try {
            const res = await Auth.forgotPasswordSubmit(username, code, newPassword)
            console.log("Password reset successfully", res)
            dispatch({ type: FORGOT_PASSWORD_CONFIRM_SUCCESS })
            // go to login screen, give new credentials and login
            history.push({ pathname: '/login', state: { username: username, showTooltip: true, toolTipMessage: "Please login with new credentials to continue" } })
        } catch (err) {
            console.log(err)
            if (err.code === "ExpiredCodeException") {
                dispatch({ type: FORGOT_PASSWORD_CONFIRM_ERROR, payload: { errorMessage: "Expired code provided, please request a new code again" } })
            } else if (err.code === "InvalidParameterException") {
                dispatch({ type: FORGOT_PASSWORD_CONFIRM_ERROR, payload: { errorMessage: "Invalid code provided, please check again" } })
            } else if (err.code === "CodeMismatchException") {
                dispatch({ type: FORGOT_PASSWORD_CONFIRM_ERROR, payload: { errorMessage: "Invalid verification code provided, please try again" } })
            } else {
                dispatch({ type: FORGOT_PASSWORD_CONFIRM_ERROR, payload: { errorMessage: "Something went wrong, please try again later" } })
            }
        }
    }
}

export const signOut = (history) => {
    return async (dispatch) => {
        try {
            await logout()
            dispatch({ type: LOGOUT_SUCCESS })
            dispatch({ type: CLEAR_STORE })
            history.push('/')
        } catch (err) {
            console.log(err)
        }
    }
}

export const fetchMyProfile = () => {
    return async (dispatch) => {
        try {
            let config = {
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.get('UsersAPI', `/`, config)
            console.log('response', response)
            const success = _.get(response, 'success');

            if (success) {
                const profile = _.get(response, 'data');
                dispatch({ type: FETCH_MY_PROFILE_SUCCESS, payload: profile });
            } else {
                throw new Error('fetching my profile failed')
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export const createUser = (newUser, callBackAction = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: CREATE_USER })
        try {
            let postData = {
                body: newUser,
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };
            const response = await API.post('UsersAPI', `/admin/users`, postData)
            const success = _.get(response, 'success');



            if (success) {
                dispatch({ type: CREATE_USER_SUCCESS });
                dispatch(showModal({ title: 'Success', body: 'New user created successfully', isSuccess: true }))
                dispatch(fetchCompanyUsers(newUser.companyId));
                callBackAction()
            } else {
                dispatch({ type: CREATE_USER_ERROR });
                dispatch(showModal({
                    title: 'Failed', body: _.get(response, 'error', 'Creating a new user failed. Please try again'), isError: true
                }))
            }
        } catch (error) {
            console.log(error)
            dispatch({ type: CREATE_USER_ERROR });
            dispatch(showModal({ title: 'Failed', body: 'Creating a new user failed. Please try again', isError: true }))
        }
    }
}

export const fetchCompanyUsers = (companyId = null) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_COMPANY_USERS });
        try {
            let config = {
                queryStringParameters: {
                    "companyId": companyId
                },
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.get('UsersAPI', `/admin/users`, config)
            const success = _.get(response, 'success');

            if (success) {
                const users = _.get(response, 'data');
                dispatch({ type: FETCH_COMPANY_USERS_SUCCESS, payload: { users } });
            } else {
                throw new Error('fetching company users failed')
            }
        } catch (error) {
            console.log(error)
            dispatch({ type: FETCH_COMPANY_USERS_ERROR });
        }
    }
}

export const readCompanyNotice = (noticeId) => {
    return async (dispatch) => {
        try {
            let postData = {
                body: { noticeId },
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };
            await API.put('UsersAPI', `/company-notice/seen`, postData)
            dispatch({ type: COMPANY_NOTICE_SEEN_SUCCESS, payload: { id: noticeId } })
        } catch (error) {
            console.log(error)
        }
    }
}

export const updateUserProfile = (companyId = null, companyData = null, userData = null, callBackAction = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_USER_PROFILE, payload: {} })
        try {
            let postData = {
                body: {
                    companyId,
                    companyData: companyData !== null ? { ...companyData } : null,
                    userData: userData !== null ? { ...userData } : null,
                },
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };
            const response = await API.put('UsersAPI', `/user-update/${companyId}`, postData)
            const success = _.get(response, 'success');
            if (success) {
                dispatch({ type: UPDATE_USER_PROFILE_SUCCESS, payload: { companyData: { ...companyData, ...userData } } })
            } else {
                dispatch({ type: UPDATE_USER_PROFILE_FAIL, payload: {} })
            }

            callBackAction()
        } catch (error) {
            dispatch({ type: UPDATE_USER_PROFILE_FAIL, payload: {} })
            callBackAction()
            console.log(error)
        }
    }
}

export const useRegister = (companyData = {}, callback = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: USER_REGISTER })
        try {
            const logo = await uploadImgToS3(companyData["logo"], false);
            let company = { ...companyData, logo: logo.url }
            let postData = {
                body: {
                    company: company,
                },
            };
            const response = await API.post('UsersAPI', `/user/company/register`, postData)
            const success = _.get(response, 'success');
            if (success) {
                dispatch({ type: USER_REGISTER_SUCCESS, payload: { company } })
                dispatch(showModal({ title: 'Success', body: `We have successfully received your request, we will review your company and inform you via ${company["email"]}`, isSuccess: true }))
                callback()
            } else {
                const message = _.get(response, "message", "New registring faild. Please try again")
                dispatch({ type: USER_REGISTER_FAIL })
                dispatch(showModal({
                    title: 'Failed', body: message, isError: true
                }))
            }
        } catch (error) {
            console.log(error)
            dispatch({ type: USER_REGISTER_FAIL })
            dispatch(showModal({
                title: 'Failed', body: 'New registring faild. Please try again', isError: true
            }))
        }
    }
}

